import { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Assets, TalkChannelFontColors } from '../../Codes'
import classNames from 'classnames'
import NoneAnchor from '../../../components/NoneAnchor'
import Icon from '../../../components/Icon'

const TalkChannelPreview = ({
  channel,
  basic: {
    licenseNumber,
    license: { recommendLicenseNumber, customLicenseNumber },
    bothLegalNoticeChecked,
    licenseReview,
  },
  type,
  data: {
    thumbnail,
    backgroundColor,
    proposalPhraseTop,
    proposalPhraseBottom,
    actionInduction,
    fontColor,
    fontColorLegal,
  },
}) => {
  const isEmpty = useMemo(
    () => backgroundColor === undefined,
    [backgroundColor]
  )
  return (
    <>
      {type === Assets.THUMBNAIL_RECOMMEND.name ? (
        <div
          className={classNames('material_default talkch', {
            type_dark: !isEmpty && fontColor === TalkChannelFontColors.BLACK,
            no_text: isEmpty,
          })}
          style={{ background: backgroundColor }}>
          <div className="ad_thumb">
            <span className="inner_thumb">
              <NoneAnchor className="link_thumb">
                <span className="thumb_bg">
                  {thumbnail && (
                    <img
                      src={thumbnail.url}
                      width="118"
                      className="img_thumb"
                      alt="소재이미지"
                    />
                  )}
                </span>
              </NoneAnchor>
            </span>
          </div>
          <div className="inner_cont">
            <div className="ad_info">
              <NoneAnchor className="ad_desc">
                {channel?.talkChannel?.name || '비즈채널을 선택하세요.'}
              </NoneAnchor>
            </div>
            <strong className="ad_subject">
              <NoneAnchor className="subject_link type_subject1">
                {proposalPhraseTop || '상단 홍보문구'}
              </NoneAnchor>
              {(bothLegalNoticeChecked || licenseReview) &&
              recommendLicenseNumber.trim() !== '' ? (
                <span
                  className={classNames('ad_set', {
                    fc_black: fontColor === TalkChannelFontColors.BLACK,
                  })}>
                  {recommendLicenseNumber || '법적고지문구'}
                </span>
              ) : (!bothLegalNoticeChecked || licenseReview) &&
                licenseNumber.trim() !== '' ? (
                <span
                  className={classNames('ad_set', {
                    fc_black: fontColor === TalkChannelFontColors.BLACK,
                  })}>
                  {licenseNumber || '법적고지문구'}
                </span>
              ) : bothLegalNoticeChecked ? (
                <NoneAnchor className="subject_link"></NoneAnchor>
              ) : (
                <NoneAnchor className="subject_link">
                  {proposalPhraseBottom || '하단 홍보문구'}
                </NoneAnchor>
              )}
            </strong>
            <div className="ad_ch">
              <NoneAnchor className="btn_ad">
                <Icon name="talkch">채널 추가</Icon>
              </NoneAnchor>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={classNames('material_default talkch type_advanced', {
            type_dark: !isEmpty && fontColor === TalkChannelFontColors.BLACK,
            no_text: isEmpty,
          })}
          style={{ background: backgroundColor }}>
          <div className="inner_cont">
            <div className="ad_info">
              <NoneAnchor className="ad_desc">
                {channel?.talkChannel?.name || '비즈채널을 선택하세요.'}
              </NoneAnchor>
            </div>
            <strong className="ad_subject">
              <NoneAnchor className="subject_link type_subject1">
                {proposalPhraseTop || '상단 홍보문구'}
              </NoneAnchor>
              <NoneAnchor className="subject_link">
                {proposalPhraseBottom || '하단 홍보문구'}
              </NoneAnchor>
            </strong>
            <div className="ad_ch">
              <NoneAnchor className="btn_link">
                {actionInduction || '행동유도버튼'}
              </NoneAnchor>
              <NoneAnchor className="btn_ad">
                <Icon name="talkch" />
                채널 추가
              </NoneAnchor>
            </div>
          </div>
          <div className="ad_thumb">
            <span className="inner_thumb">
              <NoneAnchor className="link_thumb">
                <span className="thumb_bg">
                  {thumbnail && (
                    <img
                      src={thumbnail.url}
                      width="404"
                      className="img_thumb"
                      alt="소재이미지"
                    />
                  )}
                </span>
              </NoneAnchor>
              {(bothLegalNoticeChecked || licenseReview) &&
              customLicenseNumber.trim() !== '' ? (
                <span
                  className={classNames('ad_set', {
                    fc_black: fontColorLegal === TalkChannelFontColors.BLACK,
                  })}>
                  {customLicenseNumber || '법적고지문구'}
                </span>
              ) : (!bothLegalNoticeChecked || licenseReview) &&
                licenseNumber.trim() !== '' ? (
                <span
                  className={classNames('ad_set', {
                    fc_black: fontColorLegal === TalkChannelFontColors.BLACK,
                  })}>
                  {licenseNumber || '법적고지문구'}
                </span>
              ) : (
                <Fragment />
              )}
            </span>
          </div>
        </div>
      )}
    </>
  )
}

TalkChannelPreview.propTypes = {
  channel: PropTypes.shape({
    talkChannel: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  basic: PropTypes.shape({
    licenseNumber: PropTypes.string,
    bothLegalNoticeChecked: PropTypes.any,
    license: PropTypes.shape({
      recommendLicenseNumber: PropTypes.string,
      customLicenseNumber: PropTypes.string,
    }),
    licenseReview: PropTypes.bool,
  }),
  type: PropTypes.oneOf([
    Assets.THUMBNAIL_RECOMMEND.name,
    Assets.THUMBNAIL_CUSTOM.name,
  ]).isRequired,
  data: PropTypes.shape({
    thumbnail: PropTypes.shape({
      id: PropTypes.string,
      url: PropTypes.string,
      name: PropTypes.string,
      size: PropTypes.number,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    backgroundColor: PropTypes.string,
    proposalPhraseTop: PropTypes.string,
    proposalPhraseBottom: PropTypes.string,
    actionInduction: PropTypes.string,
    fontColor: PropTypes.string,
    fontColorLegal: PropTypes.string,
  }),
}
export default TalkChannelPreview
